import { render, staticRenderFns } from "./CoinNetworkDetails.vue?vue&type=template&id=5b4c2af2&scoped=true&"
import script from "./CoinNetworkDetails.vue?vue&type=script&lang=ts&"
export * from "./CoinNetworkDetails.vue?vue&type=script&lang=ts&"
import style0 from "./CoinNetworkDetails.vue?vue&type=style&index=0&id=5b4c2af2&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4c2af2",
  null
  
)

export default component.exports